/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：956
 */

var r = require(/* 240 */"../1282/240")
var o = require(/* 443 */"../1774/443")
var i = require(/* 246 */"../1782/246/index")("species")
module.exports = function (e, t) {
  var n
  var /* [auto-meaningful-name] */rE$constructor = r(e).constructor
  return undefined === rE$constructor || undefined == (n = r(rE$constructor)[i]) ? t : o(n)
}
